import Marquee from "react-fast-marquee";
import { useLanguage } from "@/lang";

export const EditorialMarquee = () => {
  const { copy } = useLanguage();

  return (
    <div data-testid="editorial-marquee" className="border-y border-white/10 py-6 md:py-8 overflow-hidden bg-[#050505]">
      <Marquee speed={30} gradient={false} pauseOnHover>
        {copy.marquee.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display italic text-3xl md:text-5xl text-zinc-600 mx-6 md:mx-10">{w}</span>
            <span className="w-2 h-2 rounded-full bg-zinc-700" />
          </span>
        ))}
      </Marquee>
    </div>
  );
};
